import { useEffect } from 'preact/hooks';
import { online } from '../state/store';

/** A quiet note when the connection drops (F12, F16). */
export function OfflineBanner() {
  useEffect(() => {
    const up = () => (online.value = true);
    const down = () => (online.value = false);
    addEventListener('online', up);
    addEventListener('offline', down);
    return () => {
      removeEventListener('online', up);
      removeEventListener('offline', down);
    };
  }, []);
  if (online.value) return null;
  return (
    <div class="offline-banner" role="status" data-testid="offline-banner">
      You’re offline. Everything you’ve opened, or downloaded for offline use, still works.
    </div>
  );
}
